import { Component, OnInit } from '@angular/core';
import { PdfMakeWrapper, Img } from 'pdfmake-wrapper';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
// importing definitions
import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';
import { AuthService } from 'src/app/services/auth.service';
import { ThrowStmt } from '@angular/compiler';
import { map } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ActivatedRoute,Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import * as Excel from 'exceljs/dist/exceljs.min.js'
import * as fs from 'file-saver';

@Component({
  selector: 'app-format-raci',
  templateUrl: './format-raci.component.html',
  styleUrls: ['./format-raci.component.scss']
})
export class FormatRaciComponent implements OnInit {

  constructor(public authService: AuthService, private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private router: Router) {
    //console.log(localStorage.getItem("actividad_nombre"));    
   }
   
   rel_pa;
   ls_area(){
      
  }
  ngOnInit() {
    var t= localStorage.getItem("t_raci");
    switch (t) {
      case 'P':
        this.Pgg4();
        break;
      case 'X':
        this.generateExcel();
          break;    
      default:
        break;
    }
  }
  async generateExcel() {
    
    //Excel Title, Header, Data
    
    //Create workbook and worksheet
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Car Data');
    //Add Row and formatting
    const title = 'R: Responsible     A: Accountable     C: Consulted     S: Support     I: Informed ';
    
    let titleRow = worksheet.addRow([title]);
    titleRow.font = { name: 'Arial', family: 4, size: 16, underline: 'double', bold: true }
    worksheet.addRow([]);
    let c=worksheet.mergeCells('A1:I1');
    c.eachCell((cell, number) => {
      cell.font = {color:{argb:"800000"}, name: 'Arial', family: 4, size: 16, underline: 'double', bold: true }

    })
    var raciname;    
    let postData1 = {
      id:localStorage.getItem("id_raci_pdf")
    }
    await this.authService.service("/api/get_raci_id",postData1)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        console.log(res);                    
        raciname=res[0].descipcion;
        worksheet.addRow([raciname]);
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de);
      });

    const header = [raciname];
    const header2 = ["Description"];
    this.tarea=[];
    let postData = {
      id_raci:localStorage.getItem("id_raci_pdf")
    }
    await this.authService.service("/api/get_proceso",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                      
        for(var i=0;i<res.length;i++){
          //console.log(res[i]);  
          header.push(res[i].Titulo);   
          header2.push(res[i].Descripcion);   
          this.tarea.push( { id:res[i].id, proceso:res[i].Titulo,descripcion:res[i].Descripcion,idx:res[i].idx}
          );
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de);
      });

      worksheet.addRow("");
    let headerRow = worksheet.addRow(header);
    let headerRow2 = worksheet.addRow(header2);
    
    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8c82f' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.font={ color:{argb:"FFFFFF"} ,size: 12};
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    headerRow2.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8c82f' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.font={ color:{argb:"000000"} ,size: 10};
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })

    this.area=[];
    await this.authService.service("/api/get_area",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                        
        for(var i=0;i<res.length;i++){
          var tx_area= "";
        if(res[i].id_ant==0){
          tx_area=res[i].area
        }else{
          if(res[i].role.toString()==""){
            tx_area=res[i].area;
          }else{
            tx_area=res[i].role;
          }
        } 
          this.area.push({ id:res[i].id,
            area:tx_area,
            idx:res[i].idx});        
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
         // swal.fire('¡Información incorrecta!', '', 'error');
    });


    this.rel_pa=[];      
    await  this.authService.service("/api/get_pa_2",postData)
   .then(
       data => {
         var dat = JSON.stringify(data);
         var res = JSON.parse(dat);             
         for(var i=0;i<res.length;i++){
           //console.log(res[i]);         
           this.rel_pa.push(
               {id:res[i].id,
               id_p:res[i].id_tarea,
               id_a:res[i].id_area,
               rol:res[i].rol,
               c:"X"});
         }
         //console.log(res); 
         //this.load_rasci(); 
         //console.log(this.rel_pa);        
       },
       error => {
           var de= JSON.stringify(error);
           var di = JSON.parse(de)
           //swal.fire('¡Información incorrecta!', '', 'error');
    });  
 
    console.log(this.area);
    const data = [];
    for(let i=0;i<this.area.length;i++){
      var d=[];
      d.push(this.area[i].area);
      for(let j=0;j<this.tarea.length;j++){
        var bnd=0;
        var rol="";
        for(let k=0;k<this.rel_pa.length;k++){
          if(this.rel_pa[k].id_p==this.tarea[j].id  &&  this.rel_pa[k].id_a==this.area[i].id){
            bnd=1;
            rol=this.rel_pa[k].rol;           
          }          
        }     
        d.push(rol);
      }
      data.push(d)
    }    
    // Add Data and Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
      
      row.eachCell((cell, number) => {
        switch (cell.value) {
          case 'R':
          case 'AR':
            cell.font={ color:{argb:'#ffffff'} ,size: 12}; 
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'f54242' },              
            }
            cell.font={ color:{argb:'FFFFFF'} ,size: 12};
            cell.alignment={horizontal:"center"}          
            break;
          case 'A':
            cell.font={ color:{argb:'3a3fd6'} ,size: 12}; 
            cell.alignment={horizontal:"center"}
            break;
          case 'C':
            cell.font={ color:{argb:'d6733a'} ,size: 12}; 
            cell.alignment={horizontal:"center"}
            break;
          case 'S':
            cell.font={ color:{argb:'4fd63a'} ,size: 12}; 
            cell.alignment={horizontal:"center"}
            break;
          case 'I':
            cell.font={ color:{argb:'000000'} ,size: 12}; 
            cell.alignment={horizontal:"center"}
            break;        
          default:
            break;
        }                
        cell.border = { top: { style: 'thin' , color: {argb:'000000'} }, 
            left: { style: 'thin' , color: {argb:'000000'} }, 
            bottom: { style: 'thin' }, 
            right: { style: 'thin', color: {argb:'000000'} } }                 
      })


      let qty = row.getCell(1);
      let color = 'cccccc';
      /*if (+qty.value < 500) {
        color = 'FF9999'
      }*/
      qty.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color }
      }
    }
    );

    worksheet.getColumn(1).width = 50;
    //worksheet.getColumn(3).width = 30;
    //worksheet.getColumn(4).width = 30;
    worksheet.addRow([]);
    //Footer Row
    let footerRow = worksheet.addRow(['Report V1.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, raciname+'.xlsx');
    });  
    setTimeout(function(){
      window.close();
    },4000);
   }
  cve=0;
  area;
  tarea;
  async Pgg4() {     
    const pdf = new PdfMakeWrapper();    
    //pdf.background(  {image: this.img_g4,  width: 612,height:792    });
    let postData = {
      id_raci:localStorage.getItem("id_raci_pdf")
    }
    this.tarea=[];
    await this.authService.service("/api/get_proceso",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                      
        for(var i=0;i<res.length;i++){
          //console.log(res[i]);            
          this.tarea.push( { id:res[i].id, proceso:res[i].Titulo,descripcion:res[i].Descripcion,idx:res[i].idx}
          );
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de);
      });    
    this.area=[];
    await this.authService.service("/api/get_area",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                        
        for(var i=0;i<res.length;i++){
          
          var tx_area= "";
        if(res[i].id_ant==0){
          tx_area=res[i].area
        }else{
          if(res[i].role.toString()==""){
            tx_area=res[i].area;
          }else{
            tx_area=res[i].role;
          }
        }
          this.area.push({ id:res[i].id,
            area:tx_area,
            idx:res[i].idx});        
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
         // swal.fire('¡Información incorrecta!', '', 'error');
      });

  
  var twidth=3000;
  if(this.tarea.length>40){
    pdf.pageSize( {width: 3900,height: 2000});
    twidth=3000;
  }else if(this.tarea.length>30){
    pdf.pageSize( {width: 2700,height: 1500});
    twidth=2000;
  }else{
    pdf.pageSize( {
      width: 1850,
      height: 1000
    });
    twidth=1500;
  }
  pdf.pageOrientation("landscape");  
   
    let postData2 = {
      id:localStorage.getItem("id_cliente")
    }
    var client_name;
    await this.authService.service("/api/get_cliente_byid",postData2)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        console.log(res[0]);
        try {
          client_name=res[0].razonsocial;  
        } catch (error) {
          client_name="";
        }
        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de);
      });
    

    let postData1 = {
      id:localStorage.getItem("id_raci_pdf")
    }
    var raciname;    
    await this.authService.service("/api/get_raci_id",postData1)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        console.log(res);                    
        raciname=res[0].descipcion;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de);
      });
      
    pdf.add(new Txt("R: Responsible     A: Accountable     C: Consulted     S: Support     I: Informed: ")
      .alignment('center').color("black").bold().fontSize(16).end);  
      pdf.add(new Txt( " ").alignment('left').color("black").bold().fontSize(18).end);  
      pdf.add(new Table([             
        [{text:"Company: "+client_name}, 
        {text:"Title: "+raciname,color:"red",alignment:'right'}], 
       ]).widths([twidth/2,twidth/2]).layout('noBorders').fontSize(16).bold().alignment('left').end);

    //this.area=[{" "," "," "," "}]
    var rows_=(this.tarea.length+1);
    var row_i=Math.ceil(twidth/rows_);
    var wdt_=[];
    for(var i=0;i<rows_;i++){
      wdt_.push(row_i);
    }
    //console.log(wdt_);
    //console.log("wdt");
    
    var column1 =new Array();
    pdf.styles({
      section: {
             }});
    column1.push({ text: 'Process',color:'#FFFFFE',fillColor:'#e8c82f'
        ,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
    for(var i=0;i<(this.tarea.length);i++){
      //console.log(this.tarea[i]);            
      column1.push({ text: this.tarea[i].proceso,color:'#FFFFFE',fillColor:'#e8c82f',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
    }
    pdf.add(new Table(
      [               
      column1      
      ]
    ).widths(wdt_).decorationColor("#000000").style("section").fontSize(11).bold().alignment('left').end);
    
    var column2=new Array();      
    column2.push({ text: 'Department',color:"#000000",fillColor:"#cccccc",fontsize:10,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
    for(var i=0;i<(this.tarea.length);i++){
      column2.push({ text: this.tarea[i].descripcion,color:"#FFFFFE",fillColor:"#e8c82f",borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
    }
    pdf.add(new Table(
      [              
      column2     
      ]
    ).widths(wdt_).fontSize(9).alignment('left').end);
    
      this.rel_pa=[];      
     await  this.authService.service("/api/get_pa_2",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);             
          for(var i=0;i<res.length;i++){
            //console.log(res[i]);         
            this.rel_pa.push(
                {id:res[i].id,
                id_p:res[i].id_tarea,
                id_a:res[i].id_area,
                rol:res[i].rol,
                c:"X"});
          }
          //console.log(res); 
          //this.load_rasci(); 
          //console.log(this.rel_pa);        
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('¡Información incorrecta!', '', 'error');
        });  
  
    //console.log(this.area.length);
    for(var j=0;j<(this.area.length);j++){
      //console.log(this.area[j])
      var column3=new Array();      
      column3.push({ text:this.area[j].area,color:"#535442",fillColor:"#cccccc",fontSize:10 ,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
      for(var i=0;i<(this.tarea.length);i++){
        var bnd=0;
        var rol="";
        for(let k=0;k<this.rel_pa.length;k++){
          if(this.rel_pa[k].id_p==this.tarea[i].id  &&  this.rel_pa[k].id_a==this.area[j].id){
            bnd=1;
            rol=this.rel_pa[k].rol;           
          }          
        }        
        switch (rol) {
          case 'R':
          case 'AR':column3.push({ text: rol,color: '#ffffff',fillColor: '#f54242',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});                
            break;
          case 'A':column3.push({ text: rol,color: '#3a3fd6',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});            
            break;
          case 'C':column3.push({ text: rol,color: '#d6733a',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});            
            break;
          case 'S':column3.push({ text: rol,color: '#4fd63a',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});            
            break;
          case 'I':column3.push({ text: rol,color: '#000000',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});            
            break;
          default:column3.push({ text:"",borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});break;
        }                
      }
      pdf.add(new Table(
        [               
          column3    
        ]
      ).widths(wdt_).bold().alignment('left').end);
    }
    
    pdf.create().download(raciname+'.pdf');  
    setTimeout(function(){
      window.close();
    },4000);//
    }

}
